import { Directive, ElementRef, HostBinding, Input, OnInit } from '@angular/core';

@Directive({
  selector: 'img[mfpLazyImage]'
})
export class LazyImageDirective implements OnInit {
  @Input() lazySrc = '';
  @HostBinding('attr.src') srcAttr = '';

  constructor(private elementRef: ElementRef<HTMLImageElement>) {}

  ngOnInit() {
    const supportsLoadingAttr = 'loading' in HTMLImageElement.prototype;
    if (supportsLoadingAttr) {
      this.elementRef.nativeElement.setAttribute('loading', 'lazy');
      this.loadImage();
    } else {
      const supportsIntersectionObserver = window && 'IntersectionObserver' in window;
      if (supportsIntersectionObserver) {
        const intersectionObserver = new IntersectionObserver(entries => {
          entries.forEach(({ isIntersecting }) => {
            if (isIntersecting) {
              this.loadImage();
              intersectionObserver.unobserve(this.elementRef.nativeElement);
            }
          });
        });
        intersectionObserver.observe(this.elementRef.nativeElement);
      } else {
        this.loadImage();
      }
    }
  }

  private loadImage() {
    this.srcAttr = this.lazySrc;
  }
}
